"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trigger = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../../");
var FormField_1 = require("../../FormField");
var utilities_1 = require("../../../utilities");
var utils_1 = require("../utils");
var throttled_1 = require("@react-hook/window-size/throttled");
var Trigger = function (_a) {
    var _b;
    var className = _a.className, disabled = _a.disabled, _c = _a.el, TriggerEl = _c === void 0 ? 'div' : _c, error = _a.error, onClearClick = _a.onClearClick, onClick = _a.onClick, onClose = _a.onClose, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, open = _a.open, placeholder = _a.placeholder, value = _a.value, shortLabel = _a.shortLabel, _d = _a.shortLabelPosition, shortLabelPosition = _d === void 0 ? 'left' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.tabIndex, tabIndex = _f === void 0 ? 0 : _f, _g = _a.rows, rows = _g === void 0 ? 1 : _g, _h = _a.clearable, clearable = _h === void 0 ? true : _h, content = _a.content, props = __rest(_a, ["className", "disabled", "el", "error", "onClearClick", "onClick", "onClose", "onBlur", "onKeyDown", "open", "placeholder", "value", "shortLabel", "shortLabelPosition", "size", "tabIndex", "rows", "clearable", "content"]);
    var focusState = react_1.useContext(utils_1.FocusContext).focusState;
    var triggerFocus = focusState.triggerFocus;
    var triggerRef = react_1.useRef(null);
    var tagArrRef = react_1.useRef([]);
    var _j = react_1.useContext(FormField_1.FormFieldContext), inputId = _j.labelFor, setFormFieldContext = _j.setFormFieldContext;
    react_1.default.useEffect(function () {
        setFormFieldContext({ inputRef: triggerRef });
        return function () { return setFormFieldContext({ inputRef: undefined }); };
    }, []); // eslint-disable-line
    react_1.default.useEffect(function () {
        var _a;
        triggerFocus && ((_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus());
    }, [triggerFocus, triggerRef]);
    var _k = react_1.useState(0), tagLineCount = _k[0], setTagLineCount = _k[1];
    var _l = react_1.useState(0), tagLineCutoffCount = _l[0], setTagLineCutoffCount = _l[1];
    var _m = react_1.useState(0), widthCutoff = _m[0], setWidthCutoff = _m[1];
    var windowWidth = throttled_1.useWindowWidth({ fps: 60 });
    react_1.default.useLayoutEffect(function () {
        var tagTopSet = new Set();
        if (value) {
            for (var i = 0; i < value.length; i++) {
                var tag = tagArrRef.current[i];
                var tagTop = Math.ceil(tag === null || tag === void 0 ? void 0 : tag.getBoundingClientRect().top);
                if (isNaN(tagTop))
                    return;
                if (!tagTopSet.has(tagTop)) {
                    tagTopSet.add(tagTop);
                    if (tagTopSet.size === rows + 1) {
                        setTagLineCutoffCount(i);
                        setWidthCutoff(windowWidth);
                    }
                }
            }
        }
        setTagLineCount(tagTopSet.size);
    }, [value, rows, windowWidth]);
    var TriggerClasses = classnames_1.default('Trigger', className, (_b = {
            'Trigger--open': open,
            'Trigger--error': error,
            'Trigger--disabled': disabled
        },
        _b["Trigger--s-" + size] = size,
        _b));
    var handleClick = function (e) {
        return onClick === undefined ? undefined : onClick(e);
    };
    var preventClick = function (e) { return e.stopPropagation(); };
    var clearClick = function (e) {
        e.stopPropagation();
        onClearClick(e);
    };
    var handleKey = function (e) {
        if (onKeyDown)
            onKeyDown(e);
        if (e.key === utilities_1.keys.tab)
            return e; // Skip tabbing
        if (e.target !== triggerRef.current)
            return e; // Trigger isn't in focus
        if (e.key === utilities_1.keys.enter ||
            e.keyCode === 32 ||
            (e.key === utilities_1.keys.down && !open) ||
            (e.key === utilities_1.keys.up && open)) {
            e.preventDefault();
            handleClick(e);
        }
    };
    var shortLabelClasses = classnames_1.default('Trigger__shortLabel', className, {
        'Trigger__shortLabel--left': shortLabelPosition === 'left',
        'Trigger__shortLabel--right': shortLabelPosition === 'right',
    });
    var getShortLabel = function () {
        if (shortLabel === undefined || shortLabel === '')
            return;
        return react_1.default.createElement("div", { className: shortLabelClasses }, shortLabel);
    };
    var getValues = function () {
        if (content) {
            return (react_1.default.createElement(__1.BodyText, { className: "Trigger__value" }, content(value)));
        }
        if (!value || value.length === 0) {
            return (react_1.default.createElement(__1.BodyText, { className: "Trigger__placeholder" }, placeholder));
        }
        if (Array.isArray(value)) {
            if (rows === 0 ||
                (rows > 0 &&
                    tagLineCount > rows &&
                    tagLineCutoffCount < value.length &&
                    widthCutoff >= windowWidth)) {
                return (react_1.default.createElement(__1.BodyText, { className: "Trigger__value" },
                    value.length,
                    " selected"));
            }
            tagArrRef.current = new Array(value.length);
            return (react_1.default.createElement(__1.TagGroup, null, value.map(function (singleValue, index) {
                var tagText = singleValue.text
                    ? singleValue.text
                    : typeof singleValue.content === 'string'
                        ? singleValue.content
                        : String(singleValue.value);
                var handleOnClose = function () { return onClose(singleValue); };
                return (react_1.default.createElement(__1.Tag, { key: index, onClose: !singleValue.disabled &&
                        onClose &&
                        !disabled &&
                        handleOnClose, onClick: preventClick, color: singleValue.color, tagRef: function (el) {
                        return (tagArrRef.current[index] = el);
                    } }, tagText));
            })));
        }
        var text = value.text
            ? value.text
            : typeof value.content === 'string'
                ? value.content
                : String(value.value);
        return react_1.default.createElement(__1.BodyText, { className: "Trigger__value" }, text);
    };
    var checkIfAllDisabled = function () {
        if (value &&
            value.length > 0 &&
            value.filter(function (item) { return item.disabled; })
                .length === value.length)
            return true;
    };
    var getClearable = function () {
        if (!clearable ||
            !value ||
            value.length === 0 ||
            Object.entries(value).length === 0 ||
            checkIfAllDisabled())
            return;
        return (react_1.default.createElement(__1.Tooltip, { text: disabled ? null : 'Clear selection', className: "d-f" },
            react_1.default.createElement(__1.Button, { disabled: disabled, xsmall: true, fill: "subtle", iconName: "clear", onClick: clearClick, className: "Trigger__clear" })));
    };
    var getArrow = function () {
        if (open)
            return 'keyboard_arrow_up';
        return 'keyboard_arrow_down';
    };
    return (react_1.default.createElement(TriggerEl, __assign({ "aria-expanded": open, className: TriggerClasses, onClick: disabled ? undefined : handleClick, tabIndex: disabled ? undefined : tabIndex, onKeyPress: handleKey, onKeyDown: handleKey, ref: triggerRef, onBlur: onBlur, id: inputId }, props),
        react_1.default.createElement(__1.Stack, null,
            shortLabelPosition === 'left' && getShortLabel(),
            getValues(),
            react_1.default.createElement(__1.Stack, { className: "Trigger__controls", spacing: 1, alignItems: "flex-start" },
                getClearable(),
                react_1.default.createElement(__1.Icon, { name: getArrow(), size: "16px", className: "Trigger__arrow" })),
            shortLabelPosition === 'right' && getShortLabel())));
};
exports.Trigger = Trigger;
//# sourceMappingURL=Trigger.js.map